export const EneBreakpoints = {
  XSmall: "(max-width: 599.98px)",
  Small: "(min-width: 600px) and (max-width: 1023.98px)",
  Medium: "(min-width: 1024px) and (max-width: 1439.98px)",
  Large: "(min-width: 1440px) and (max-width: 1919.98px)",
  XLarge: "(min-width: 1920px)"
};
